var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.RepairFunc}},[_vm._v("一键修复")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }